import {Component, Inject, NgZone} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {UtilService} from '../../services/util/util.service';

export interface StatusData {
  message?: string | string[];
  action?: Function;
  actionName?: string;
}

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent {
  public messages: string[];
  public action: Function;
  public actionName: string = 'general.api_general_link';
  public progress: number;
  readonly duration: number = 0;
  readonly frequency: number;
  readonly tick: number;
  readonly className: string | string[];

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: StatusData,
              private _snackRef: MatSnackBarRef<StatusComponent>,
              private zone: NgZone,
              public utilService: UtilService) {
    if (typeof data?.message === 'string') {
      this.messages = [data.message];
    } else {
      this.messages = data.message;
    }
    if (typeof data.action == 'function') {
      this.action = data.action;
    }
    if (data.actionName) {
      this.actionName = data.actionName;
    }
    const duration = _snackRef.containerInstance.snackBarConfig.duration;
    if (duration) {
      this.duration = duration;
    }
    this.progress = 0;
    this.frequency = 500;
    this.tick = this.frequency / this.duration * 100;
    this.className = _snackRef.containerInstance.snackBarConfig.panelClass;
    if (this.duration) {
      this.showProgress();
    }
  }

  private showProgress(): void {
    this._snackRef.containerInstance.enter();
    setTimeout(() => {
      this.zone.run(() => {
        this.progress += this.tick;
      });
      if (this.progress >= 100) {
        this.dismiss();
      } else {
        this.showProgress();
      }
    }, this.frequency);
  }

  public dismissWithAction(): void {
    this.action();
    this._snackRef.dismissWithAction();
  }

  public dismiss(): void {
    this._snackRef.dismissWithAction();
  }
}
